import React from 'react';
import {
  Master,
  BrandsDetail,
  TableDetails,
  PageWrapper,
  PanelTopWrapper,
  TitlePage,
  ContentWrapper,
  StoresList
} from 'components';

import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { BrandPopulate, UpdateBrandService } from 'services';

export const BrandsPage = (props) => {

  let { path } = useRouteMatch();

  const titles = ['', 'Nome', 'Frase', 'Ativo', 'Editar'];

  const updateEnabled = (status)=> {
    const formData = new FormData();
    formData.append("active", status.enable)
    UpdateBrandService(formData, status.id);
  }

  return (
    <>
      <Master>
        <Switch>
          <Route exact path={path}>
            <PageWrapper>
              <PanelTopWrapper padding={"py-4"}>
                <TitlePage title={'Marcas'} />
                <ContentWrapper class={'d-flex align-items-center'}>
                  <StoresList />
                </ContentWrapper>
              </PanelTopWrapper>
              <TableDetails promise={BrandPopulate()} titles={titles}  getStatus={updateEnabled}/>
            </PageWrapper>
          </Route>
          <Route path={`${path}/:topicId`}>
            <BrandsDetail />
          </Route>
        </Switch>
      </Master>
    </>
  );
};
